module.exports = __webpack_public_path__ + "img/mp.2f0703e0.png";